import { Tooltip } from '@mantine/core';
import AppIcon from '@/components/AppIcon.tsx';
import { HiOutlineCircleStack } from 'react-icons/hi2';

type Props = {
  label: string;
  size?: number;
};

const CachedExecutionIndicator = ({ label, size = 14 }: Props) => {
  return (
    <Tooltip label={label} openDelay={250} position="top">
      <span
        aria-label={label}
        role="img"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          height: `${size}px`,
          width: `${size}px`,
        }}
      >
        <AppIcon Icon={HiOutlineCircleStack} size={size} color="#868e96" />
      </span>
    </Tooltip>
  );
};

export default CachedExecutionIndicator;
